import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ToastService } from '../../Util/Toast/toast.service';
import { AssetGroupMasterFormComponent } from '../asset-group-master-form/asset-group-master-form.component';
import { AssetService } from '../../Model/AssetModule/asset.service';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-asset-group-master',
  standalone: true,
  imports: [CommonModule, DataTablesModule, RouterOutlet, RouterModule],
  templateUrl: './asset-group-master.component.html',
  styleUrl: './asset-group-master.component.scss'
})
export class AssetGroupMasterComponent {
  isDisabled: boolean = false;
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private modalService: NgbModal,
    private toast: ToastService,
    private Asset: AssetService,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.GetGroup();
  }

  GetGroup() {
    // this.isDisabled = true;
    this.Asset.LoadGroupMaster({ ESS_AssetGroupMasterID: 0, SelectType: 1 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addGroup(ID: any) {
    const modalRef = this.modalService.open(AssetGroupMasterFormComponent);
    modalRef.componentInstance.ID = ID;
    modalRef.result.then(
      (result: any) => {

        this.GetGroup();

      },
      () => { }
    );
  }
}
